import { Pipe, PipeTransform } from '@angular/core';
import { MonitoredTrain } from '../models/monitored-train';

@Pipe({
  name: 'mapTrainSearch'
})
export class MapTrainSearchPipe implements PipeTransform {

  transform(trains: MonitoredTrain[], searchTrain: string): MonitoredTrain[] {
    return searchTrain ? trains && trains.filter(train => {
      return (train.officialId && train.officialId.toString().toLowerCase().includes(searchTrain))
    }) : trains;
  }

}
